import hero from "./components/hero";
import icons from "./components/icons";
import accordion from "./components/accordion";
import testimonials from "./components/testimonials";
import glightbox from "./components/glightbox";
import tablesToLists from "./components/tablesToLists";
import tabs from "./components/tabs";
import fade from "./components/fade";
import mainMenu from "./components/main-menu";
import packery from "./components/packery";
import orderPopup from "./components/order-popup";
import dealerCard from "./components/dealer-card";
import imageGallery from "./components/imageGallery";
import cookieBar from "../../../../vendor/smokeylemon/gdpr-basics/client/src/js/cookieBar";

import app from "./app/app";

document.addEventListener("DOMContentLoaded", () => {

    cookieBar();
    hero();
    icons();
    accordion();
    testimonials();
    glightbox();
    tablesToLists();
    tabs();
    fade();
    orderPopup();
    dealerCard();
    mainMenu();
    packery();
    imageGallery();

});


window.addEventListener("load", () => {

    app();

});
